import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ProfileResponse, ProfileSchema} from '../types/profile';
import {fetchProfileData} from "../fetchProfileDate/fetchProfileDate";


const initialState: ProfileSchema = {
    readonly: true,
    isLoading: true,
    error: undefined,
    data: undefined,
};

export const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchProfileData.pending, (state) => {
                state.error = undefined;
                state.isLoading = true;
            })
            .addCase(fetchProfileData.fulfilled, (
                state,
                action: PayloadAction<ProfileResponse>,
            ) => {
                state.isLoading = false;
                state.data = action.payload.data;
            })
            .addCase(fetchProfileData.rejected, (state, action) => {
                state.isLoading = false;
                // @ts-ignore
                state.error = action.payload;
            });
    },
});

export const { actions: profileActions } = profileSlice;
export const { reducer: profileReducer } = profileSlice;
